import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class UserFeedbackService {

  constructor(private snackBar: MatSnackBar) { }

  showSuccess(message: string) {
    this.snackBar.open(message, '',{
      duration: 3000,
      panelClass: "success-dialog"
  })
  }

  showError(message: string, stayUntilClosed = false) {
    this.snackBar.open(message, stayUntilClosed ? 'Close' : '', {
      duration: stayUntilClosed ? 0 : 3000,
      panelClass: 'error-dialog'
    });
  }

}
